import { memo } from 'react';

import { messages } from './Loading.messages';
import { LoadingIcon, LoadingPanel, LoadingText } from './Loading.styles';

export const Loading = memo(() => {
    return (
        <div>
            <div style={LoadingPanel}>
                <div style={LoadingIcon} />

                <div style={LoadingText}>{messages.loadingData}</div>
            </div>
        </div>
    );
});

Loading.displayName = 'Loading';
